<template>
  <div class="no-wrap">
    <v-chip x-small class="mr-1" :color="formatted.color" />
    <span v-if="!minimal" :style="{color: formatted.color}">{{ formatted.text || 'NA' }}</span>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'issue-status',
  props: {
    value: String,
    default() {
      return '';
    },
    minimal: Boolean,
  },
  computed: {
    ...mapState(['states']),
    formatted() {
      return this.states.find(i => i.value === this.value) || {};
    },
  },
};
</script>

<style>
</style>
